import { IAppState } from '../../../AppModulesWrapper';

import { EMoneySource } from '../../types/reducers/user';
import { selectPlacingMoneySource } from '../publishTerms';

export const selectIsMasterMoneySource = (state: IAppState): boolean => {
  const {
    user: { isSubAgent },
  } = state.servicePickerWidget;

  const placingMoneySource = selectPlacingMoneySource(state);

  return isSubAgent && placingMoneySource === EMoneySource.Master;
};
